import { Component } from 'react';
import validate from '../../utils/formValidator';
import OutsideClick from './OutsideClick';

interface State {
  showInput: boolean;
  phoneNumber: string;
  showErr: boolean;
  smsSent: boolean;
}

class DownloadBlack extends Component<any, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      showInput: false,
      phoneNumber: '',
      smsSent: false,
      showErr: false,
    };
  }

  private showInputFunc = (showInput: boolean) => {
    this.setState(
      {
        showInput,
      },
      () => {
        this.props.onShowInput(this.state.showInput);
      }
    );
  };
  private validateAndSubmit = () => {
    const { phoneNumber } = this.state;
    const { sendBlackSMS } = this.props;
    const formValues = [
      {
        name: 'phone',
        labelName: '',
        placeholder: '',
        type: 'string',
        isInvalid: false,
        validationMessage: 'Enter valid Number',
        required: true,
        entityKey: '',
        className: '',
        value: phoneNumber,
      },
    ];
    const { isValid, validatedArr } = validate(formValues);
    if (!isValid) {
      this.setState({
        showErr: true,
      });
    }
    if (isValid) {
      sendBlackSMS(validatedArr[0]['value']);
      this.setState({ smsSent: true });
    }
  };

  private handleChange = (e: any) => {
    this.setState({
      phoneNumber: e.target.value,
      showErr: false,
    });
  };

  public render() {
    const { btnText, inputWidth, classname, btnClasses } = this.props;
    const { showInput, phoneNumber, showErr, smsSent } = this.state;

    return (
      <div>
        {!showInput ? (
          <button
            className={`lil-btn lil-mr-4 ${
              btnClasses ? btnClasses : 'lil-btn-blue'
            }`}
            onClick={() => this.showInputFunc(true)}
          >
            {btnText}
          </button>
        ) : (
          <div>
            {smsSent ? (
              <span className="lil-text-green-350 lil-text-green-350 lil-font-bold lil-pl-4">
                Download Link is Sent
              </span>
            ) : (
              <OutsideClick
                clickedOutside={() => {
                  this.showInputFunc(false);
                }}
                render={() => {
                  return (
                    <div className="lil-flex lil-border-grey-350 lil-border-sm lil-rounded-xl lil-py-1 lil-pl-4 lil-pr-1">
                      <input
                        placeholder="Enter your phone no"
                        value={phoneNumber}
                        onChange={this.handleChange}
                        style={{ width: inputWidth ? inputWidth : 'auto' }}
                        className={`${classname} lil-bg-transparent lil-border-none focus:lil-outline-none`}
                      />
                      <button
                        className="lil-btn lil-btn-blue"
                        onClick={this.validateAndSubmit}
                      >
                        Send download link
                      </button>
                    </div>
                  );
                }}
              />
            )}
            {showErr && (
              <div className="lil-text-red lil-text-red lil-text-s-14 lil-pl-1 lil-pt-2">
                Enter valid Number
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default DownloadBlack;



// WEBPACK FOOTER //
// ./components/common/downloadBlack.tsx